import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { HeaderCell, LengthCell } from './length-cells';

export const createLengthColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'length',
  Header: HeaderCell,
  Cell: LengthCell,
  width: 1,
  minWidth: 100,
});
